import { useMutation } from "@tanstack/react-query";
import { createAccommodation } from "../api/accommodation.api";
import { AccomodationFormData, AccommodationSearchParams } from "../types/accomodation.types";
import { searchAccommodations } from "../api/accommodation.api";
import { AxiosError } from "axios";

interface CreateAccommodationResponse {
  id: number;
  // Agrega aquí otros campos que devuelva la API
}

const createAccommodationMutation = async (data: AccomodationFormData): Promise<CreateAccommodationResponse> => {
  try {
    const response = await createAccommodation(data);
    return response.data;
  } catch (error) {
    console.log(error);
    if (error instanceof AxiosError) {
      console.error('Error del servidor:', {
        mensaje: error.response?.data?.message,
        errores: error.response?.data?.errors
      });
      throw error;
    }
    throw new Error('Error al crear el alojamiento');
  }
};

export const useAccommodationCreate = () => {
  return useMutation({
    mutationFn: createAccommodationMutation,
    mutationKey: ['accommodationCreate']
  });
};

interface SearchAccommodationResponse {
  id: number;
  // Agrega aquí otros campos que devuelva la API
}

const searchAccommodationMutation = async (
  data: AccommodationSearchParams
): Promise<SearchAccommodationResponse> => {
  try {
    const response = await searchAccommodations(data);
    return response.data;
  } catch (error) {
    console.error(error);
    if (error instanceof AxiosError) {
      console.error('Error del servidor:', {
        mensaje: error.response?.data?.message,
        errores: error.response?.data?.errors
      });
      throw error;
    }
    throw new Error('Error al buscar alojamientos');
  }
};

export const useAccommodationSearch = () => {
  return useMutation({
    mutationFn: searchAccommodationMutation,
    mutationKey: ['accommodationSearch']
  });
}; 